<div class="modal-header">
    <h5 id="chatModalTitle" class="modal-title">Chat with Your Proctor</h5>
    <button type="button" class="close" aria-label="Close chat window" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" #chatModalBody id="chatModalDesc" role="region" aria-label="Chat history" tabindex="0" >
    <div class="chat-modal-chat">
        <div class="chat-modal-chat-inner" id="chatcontainer">
            <div *ngFor="let chatline of chat" class="chat-modal-chat-line"
                [ngClass]="{local: chatline.local, remote: !chatline.local}">
                <span [ngClass]="{'chat-you-span': chatline.local, 'chat-proctor-span': !chatline.local}"><span
                        *ngIf="chatline.local">You: </span><span *ngIf="!chatline.local">Proctor: </span></span>
                <span [innerHTML]="chatline.message"></span>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <div class="w-100">
        <textarea style="width: 100%; padding: 3px" (keydown.enter)="sendChatMessage($event)" #chattextarea
            [disabled]="!this.chatOpened" aria-label="Type your message"></textarea>
    </div>
    <div class="sendbuttondiv">
        <button (click)="sendChatMessage(null)" class="btn btn-primary" aria-label="Send message">Send</button>
    </div>
</div>